import Vue from 'vue';
import Router from 'vue-router';
import VueResource from 'vue-resource';
import Upload from '@/components/Upload';
import Results from '@/components/Results';
import History from '@/components/History';
import Feed from '@/components/Feed';
import About from '@/components/About';
import Account from '@/components/Account';
import TOS from '@/components/TOS';
import Welcome from '@/components/Welcome';
import Plans from '@/components/Plans';
import Search from '@/components/Search';
import AuthService from './../auth/AuthService';

Vue.use(Router);
Vue.use(VueResource);

const auth = new AuthService();

export default new Router({
    routes: [
        {
            path: '/account',
            name: 'Account',
            component: Account,
            beforeEnter: (to, from, next) => {
                if (!auth.isAuthenticated()) {
                    next(false);
                    location.reload();
                } else {
                    next();
                }
            },
        },
        {
            path: '/',
            name: 'Home',
            component: Upload,
        },
        {
            path: '/upload',
            name: 'Upload',
            component: Upload,
        },
        {
            path: '/results/:id',
            name: 'Results',
            component: Results,
        },
        {
            path: '/history',
            name: 'History',
            component: History,
            beforeEnter: (to, from, next) => {
                if (!auth.isAuthenticated()) {
                    // next();
                    // auth.login();
                    next(false);
                    location.reload();
                } else {
                    next();
                }
            },
        },
        {
            path: '/search',
            name: 'Search',
            component: Search,
            beforeEnter: (to, from, next) => {
                if (!auth.isAuthenticated()) {
                    // next();
                    // auth.login();
                    next(false);
                    location.reload();
                } else {
                    next();
                }
            },
        },
        {
            path: '/feed',
            name: 'Feed',
            component: Feed,
        },
        {
            path: '/about',
            name: 'About',
            component: About,
        },
        {
            path: '/tos',
            name: 'TOS',
            component: TOS,
        },
        {
            path: '/welcome',
            name: 'Welcome',
            component: Welcome,
        },
        {
            path: '/plans',
            name: 'Plans',
            component: Plans,
            // beforeEnter: (to, from, next) => {
            //     if (!auth.isAuthenticated()) {
            //         next(false);
            //         location.reload();
            //     } else {
            //         next();
            //     }
            // },
        },
        { path: '*',
            redirect: '/',
        },
    ],
    mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js